export function createStack(size, wallTraits, stackArray, stackHeights) {
  const stacks = {
    32: [0, 10, 20, 26],
    27: [0, 9, 18, 23],
    24: [0, 8, 16, 20],
    20: [0, 6, 12, 16],
    16: [0, 8, 16, 20],
  };

  const xpadding = 30;
  const ypadding = 1;
  const boxWidth = 120;
  let x = xpadding;
  let y = ypadding;
  let stack = [];
  let topStack = 0;

  function stackMaker(i, stacks) {
    let previous = 0;

    for (let k = 0; k < stacks.length; k++) {
      if (i === stacks[k]) {
        topStack = stacks[k] - previous;
        x = (boxWidth + 4) * k + xpadding;

        y = ypadding;
        previous = stacks[k];
      }
    }
  }

  let wallArray = [...wallTraits];

  for (let i = 0; i < stackArray.length; i++) {
    let nextWall = {};

    stackMaker(i, stackHeights.length ? stackHeights : stacks[size]);

    nextWall = wallArray[stackArray[i]];
    nextWall.y = y;
    nextWall.x = x;
    if (i === topStack - 1) {
      nextWall.top = true;
    } else {
      nextWall.top = false;
    }
    stack.push(nextWall);
    y++;
  }
  return stack;
}
